
import { throwError as observableThrowError, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions, } from '@angular/http';

@Injectable()
export class MyOrderService {
    constructor(private http: Http) { }
    getOrders(customerId: string, searchNo: string, pageNo: string, date: string, searchKey: string) {
        let url = `${environment.api.serviceurl}` + "GetOrders?customerid=" + customerId + "&searchNo=" + searchNo + "&searchPage=" + pageNo + "&searchDdate=" + date + "&searchKey=" + searchKey;
        return this.http.get(url).pipe(
            map((response: Response) => {
                let pacData = response.json();
                let t = pacData.GetOrdersResult;
                let p = ('(' + t + ')');
                let s = eval(p);
                return s;
            }));
    }

    serviceCall1(data: string) {
        let url = `${environment.api.serviceurl}` + "CallOraText";
        return this.http.post(url, data).pipe(
            catchError(this.handleError));
    }

    getorders(customerId: string, searchNo: string, pageNo: string, date: string, searchKey: string, sKey: string): Observable<any> {
        let url = `${environment.api.serviceurl}` + "getOrders";
        let orderData = { "customerid": customerId, "searchNo": searchNo, "pageNo": pageNo, "date": date, "searchKey": searchKey };
        let headers = new Headers();
        headers.set('Content-Type', 'application/json');
        headers.set("authinfo", sKey);
        let data = JSON.stringify(orderData);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(url, data, options).pipe(
            map(this.extractData),
            catchError(this.handleError),);
    }

    setonholdGeom1(type: string, geom: string): Observable<any> {
        let url = `${environment.api.serviceurl}` + "OnHoldSetGeom";
        let orderData = { "type": type, "geom": geom };
        let headers = new Headers();
        headers.set('Content-Type', 'application/json');

        let data = JSON.stringify(orderData);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(url, data, options).pipe(
            map(this.extractdata),
            catchError(this.handleError),);
    }

    getrangeorders(customerId: string, startNo: string, endNo: string, searchKey: string, sKey: string): Observable<any> {
        let url = `${environment.api.serviceurl}` + "getRangeOrders";
        let orderData = { "customerid": customerId, "startNo": startNo, "endNo": endNo, "searchKey": searchKey };
        let headers = new Headers();
        headers.set('Content-Type', 'application/json');
        headers.set("authinfo", sKey);
        let data = JSON.stringify(orderData);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(url, data, options).pipe(
            map(this.extractData),
            catchError(this.handleError),);
    }

    getDownloadUrl(f: string, n: string) {
        let url = `${environment.api.serviceurl}` + "DownloadAll?f=" + f + "&n=" + n;
        return this.http.get(url).pipe(
            map((response: Response) => {

                let pacData = response.json();
                let t = pacData.DownloadAllResult;
                return t;
            }),
            catchError(this.handleError),);
    }

    getdownloadUrl(customerId: string, f: string, n: string, sKey: string): Observable<any> {
        let url = `${environment.api.serviceurl}` + "downloadAll";
        let orderData = { "customerid": customerId, "f": f, "n": n };
        let headers = new Headers();
        headers.set('Content-Type', 'application/json');
        headers.set("authinfo", sKey);
        let data = JSON.stringify(orderData);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(url, data, options).pipe(
            map(this.extractdata),
            catchError(this.handleError),);
    }

    downloadAll(orderno: string): Observable<any> {
        let url = `${environment.api.downloadAllUrl}` + orderno;
        return this.http.get(url).pipe(
            map((response: Response) => {
                let data = response.json();
                return data
            }),
            catchError(this.handleError),)
    }

    getOnholdGeom(orderid: string) {
        let url = `${environment.api.serviceurl}` + "onHoldGetGeom?orderid=" + orderid;
        return this.http.get(url).pipe(
            map((response: Response) => {

                let pacData = response.json();
                let t = pacData.onHoldGetGeomResult;
                if (t == "") {
                    return t
                }
                let p = ('(' + t + ')');
                let s = eval(p);
                return s;
            }),
            catchError(this.handleError),);
    }

    getonholdGeom(customerId: string, orderid: string, sKey: string): Observable<any> {
        let url = `${environment.api.serviceurl}` + "OnHoldGetGeom";
        let orderData = { "customerid": customerId, "stringData": orderid };
        let headers = new Headers();
        headers.set('Content-Type', 'application/json');
        headers.set("authinfo", sKey);
        let data = JSON.stringify(orderData);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(url, data, options).pipe(
            map(this.extractData),
            catchError(this.handleError),);
    }

    setOnholdGeom(orderid: string, email: string, type: string, geom: string) {
        let url = `${environment.api.serviceurl}` + "onHoldSetGeom?orderid=" + orderid + "&email=" + email + "&type=" + type + "&geom=" + geom;
        return this.http.get(url).pipe(
            map((response: Response) => {

                let pacData = response.json();
                let t = pacData.onHoldSetGeomResult;
                return t;
            }),
            catchError(this.handleError),);
    }


    setonholdGeom(customerId: string, orderid: string, email: string, type: string, geom: string, sKey: string): Observable<any> {
        let url = `${environment.api.serviceurl}` + "OnHoldSetGeom";
        let orderData = { "customerid": customerId, "orderid": orderid, "email": email, "type": type, "geom": geom };
        let headers = new Headers();
        headers.set('Content-Type', 'application/json');
        headers.set("authinfo", sKey);
        let data = JSON.stringify(orderData);
        let options = new RequestOptions({ headers: headers });
        return this.http.post(url, data, options).pipe(
            map(this.extractdata),
            catchError(this.handleError),);
    }

    getContractors(customerId: string): Observable<any> {
        let url = `${environment.api.url}`;
        let orderData = { "PROCEDURE":"getContractors", "CUSTOMER_ID": customerId};
        let data = JSON.stringify(orderData);
        return this.http.post(url, data).pipe(
            catchError(this.handleError),);
    }

    assignContractor(customerId: string, contractorId: string, orderNo: string) {
        let url = `${environment.api.url}`;
        let orderData = {"PROCEDURE":"assignContractorOrder","ORDER_NUM":orderNo,"CONTRACTOR_CUSTOMER_ID":contractorId,"CUSTOMER_ID":customerId}
        let data = JSON.stringify(orderData);
        return this.http.post(url, data).pipe(
            catchError(this.handleError),);
    }

    removeContractor(customerId: string, contractorId: string, orderNo: string) {
        let url = `${environment.api.url}`;
        let orderData = {"PROCEDURE":"removeContractorOrder","ORDER_NUM":orderNo,"CONTRACTOR_CUSTOMER_ID":contractorId,"CUSTOMER_ID":customerId}
        let data = JSON.stringify(orderData);
        return this.http.post(url, data).pipe(
            catchError(this.handleError),);
    }

    private extractdata(res: Response) {
        let body = res.json();
        return body.orderid || {};
    }

    private extractData(res: Response) {
        let body = res.json();
        if (body.status == "OK") {
            let jsonbody = JSON.parse(body.orderid);
            return jsonbody || {};
        } else {
            observableThrowError(body.message);
            return []
        }
    }

    private handleError(error: any) {
        let errMsg = '';
        if (error.message) {
            errMsg = error.message;
        } else {
            errMsg = error.status ? '${error.status} - ${error.statusText}' : 'Server error';
        }
        return observableThrowError(errMsg);
    }
}
